import styled from 'styled-components'

export const Container = styled.div`
	margin: 0 auto;
	height: 85%;
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-direction: column;
`
